import { $http } from '../config';

const Permissions = {
	getPermissions: () => $http(`/permissions`).then(r => r.data)
};

export default Permissions;
